// Junior Science Unit Tests - Years 7-10
// Assessment materials for Basic Science

export const year7ScienceUnitTests = {
  year: 7,
  subject: "Basic Science",
  strands: {
    strand1: {
      name: "Measurement & Physical Science",
      tests: [
        {
          id: "7.1-test",
          title: "Measurement Test",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "Name the instrument used to measure each of the following:\n(a) The length of a desk\n(b) The volume of water\n(c) The mass of a stone\n(d) The temperature of water",
              marks: 4,
              answer: "(a) Ruler or tape measure\n(b) Measuring cylinder\n(c) Balance/scales\n(d) Thermometer"
            },
            {
              id: 2,
              question: "Convert the following:\n(a) 2.5 km to meters\n(b) 350 cm to meters\n(c) 1500 ml to liters\n(d) 2.4 kg to grams",
              marks: 4,
              answer: "(a) 2500 m\n(b) 3.5 m\n(c) 1.5 L\n(d) 2400 g"
            },
            {
              id: 3,
              question: "A measuring cylinder contains 50 ml of water. A small rock is added and the water level rises to 65 ml. What is the volume of the rock?",
              marks: 3,
              answer: "Volume of rock = 65 - 50 = 15 ml (or 15 cm³)"
            },
            {
              id: 4,
              question: "Why should you read a measuring cylinder at eye level?",
              marks: 2,
              answer: "To avoid parallax error and get an accurate reading. The meniscus should be read at the bottom of the curve."
            },
            {
              id: 5,
              question: "A student estimates that a classroom is about 8 m long. Using a meter ruler, they measure it as 7.8 m. Was their estimate reasonable? Explain.",
              marks: 3,
              answer: "Yes, the estimate was reasonable because it was close to the actual measurement (within 0.2 m or about 2.5% difference)."
            }
          ]
        },
        {
          id: "7.4-test",
          title: "Magnetism and Electricity Test",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "List three materials that are attracted to magnets.",
              marks: 3,
              answer: "Iron, steel, nickel (also cobalt)"
            },
            {
              id: 2,
              question: "What happens when:\n(a) Two north poles are brought together?\n(b) A north pole and south pole are brought together?",
              marks: 4,
              answer: "(a) They repel each other\n(b) They attract each other"
            },
            {
              id: 3,
              question: "Draw a simple circuit with one battery, one switch, and one light bulb. Label all components.",
              marks: 4,
              answer: "Drawing should show: cell with + and - labeled, switch symbol, bulb symbol, all connected in a complete circuit with correct symbols."
            },
            {
              id: 4,
              question: "Why are electrical wires covered with plastic?",
              marks: 2,
              answer: "Plastic is an insulator - it stops electricity from escaping and prevents electric shocks. It also prevents short circuits."
            },
            {
              id: 5,
              question: "A student builds a circuit but the bulb doesn't light up. Give three possible reasons.",
              marks: 3,
              answer: "Possible reasons: dead battery, broken wire, loose connection, blown bulb, circuit not complete (switch open), wrong way round (for some components)"
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Water & Materials",
      tests: [
        {
          id: "7.2-test",
          title: "Water Test",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Name the process for each change:\n(a) Ice to water\n(b) Water to steam\n(c) Steam to water\n(d) Water to ice",
              marks: 4,
              answer: "(a) Melting\n(b) Evaporation/boiling\n(c) Condensation\n(d) Freezing"
            },
            {
              id: 2,
              question: "At what temperature does water:\n(a) Freeze?\n(b) Boil?",
              marks: 2,
              answer: "(a) 0°C\n(b) 100°C"
            },
            {
              id: 3,
              question: "Draw and label the water cycle showing: evaporation, condensation, precipitation, and runoff.",
              marks: 5,
              answer: "Diagram should show: sun heating water, water vapor rising (evaporation), clouds forming (condensation), rain falling (precipitation), water flowing back to sea (runoff)"
            },
            {
              id: 4,
              question: "Explain how you would separate sand from salt water.",
              marks: 4,
              answer: "1. Filter the mixture to remove sand (collect sand on filter paper)\n2. Heat the salt water to evaporate the water (collect salt crystals left behind)"
            },
            {
              id: 5,
              question: "Why does water come out of a tap faster on lower floors of a building?",
              marks: 3,
              answer: "Water pressure increases with depth. The lower floors are deeper below the water tank, so there is greater pressure pushing the water out."
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Living Things",
      tests: [
        {
          id: "7.3-test",
          title: "Living Things Test",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "What is meant by 'adaptation'? Give two examples of adaptations in Vanuatu organisms.",
              marks: 4,
              answer: "Adaptation: A feature that helps an organism survive in its environment. Examples: Coconut palm flexible trunk (survives cyclones), flying fox large eyes (night vision), mangrove aerial roots (get oxygen in waterlogged soil)"
            },
            {
              id: 2,
              question: "Write a food chain from a Vanuatu garden. Include a producer and at least two consumers.",
              marks: 3,
              answer: "Example: Leaf → Caterpillar → Bird → Hawk (or similar with correct arrow direction)"
            },
            {
              id: 3,
              question: "What is the difference between a producer and a consumer?",
              marks: 2,
              answer: "Producer: Makes its own food using sunlight (plants). Consumer: Eats other organisms for food (animals)"
            },
            {
              id: 4,
              question: "Draw and label a plant cell showing: cell wall, cell membrane, nucleus, cytoplasm, and vacuole.",
              marks: 5,
              answer: "Drawing should show all five labeled parts with cell wall on outside, membrane inside it, large central vacuole, cytoplasm, and nucleus."
            },
            {
              id: 5,
              question: "What are the three main parts found in ALL cells?",
              marks: 3,
              answer: "Cell membrane, cytoplasm, and nucleus"
            }
          ]
        }
      ]
    }
  }
};

export const year8ScienceUnitTests = {
  year: 8,
  subject: "Basic Science",
  strands: {
    strand1: {
      name: "Biological Science: Cells and Body Systems",
      tests: [
        {
          id: "8.1-test",
          title: "Cells and Body Systems Test",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Draw and label a plant cell and an animal cell. Identify TWO structures found in a plant cell but NOT in an animal cell.",
              marks: 6,
              answer: "Plant cell should show: cell wall, cell membrane, nucleus, cytoplasm, chloroplast, vacuole. Animal cell: cell membrane, nucleus, cytoplasm. Two structures unique to plant cells: cell wall and chloroplasts (also large vacuole)."
            },
            {
              id: 2,
              question: "List the levels of organisation in living things, from smallest to largest.",
              marks: 5,
              answer: "Cells → Tissues → Organs → Organ Systems → Organisms"
            },
            {
              id: 3,
              question: "Trace the path of food through the human digestive system, naming FIVE organs it passes through.",
              marks: 5,
              answer: "Mouth → Oesophagus → Stomach → Small intestine → Large intestine (also rectum/anus for exit)"
            },
            {
              id: 4,
              question: "Explain how the respiratory system and circulatory system work together to deliver oxygen to body cells.",
              marks: 6,
              answer: "Air enters lungs through trachea and bronchi. In alveoli, oxygen passes into blood (gas exchange). Oxygenated blood travels through pulmonary veins to heart. Heart pumps blood through arteries to body cells. Oxygen is delivered to cells for respiration."
            },
            {
              id: 5,
              question: "In Vanuatu, many people rely on local food gardens. Explain how good nutrition supports the proper functioning of body systems.",
              marks: 5,
              answer: "Local gardens provide fruits and vegetables with vitamins for immune system, carbohydrates from root crops for energy, proteins from legumes for muscle/tissue growth. Good nutrition supports digestive system to process food, circulatory system to transport nutrients, and immune system to fight disease."
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Chemical Science: Chemical Reactions",
      tests: [
        {
          id: "8.2-test",
          title: "Chemical Reactions Test",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "Explain the difference between a physical change and a chemical change. Give TWO examples of each.",
              marks: 6,
              answer: "Physical change: no new substance formed, can be reversed (e.g., melting ice, dissolving salt). Chemical change: new substance formed, usually cannot be reversed (e.g., rusting iron, burning wood)."
            },
            {
              id: 2,
              question: "List FOUR types of evidence that a chemical reaction has occurred.",
              marks: 4,
              answer: "1. Colour change 2. Gas production (bubbles) 3. Temperature change (exothermic/endothermic) 4. Precipitate formation"
            },
            {
              id: 3,
              question: "What is the pH value of: (a) a strong acid (b) a neutral substance (c) a strong base? Name a common substance found in Vanuatu for each.",
              marks: 6,
              answer: "(a) pH 1-3, e.g., citrus fruit juice/vinegar (b) pH 7, e.g., pure water (c) pH 11-14, e.g., coral lime (calcium hydroxide) or soap"
            },
            {
              id: 4,
              question: "Explain what happens during a neutralisation reaction. Give a practical example from everyday life in Vanuatu.",
              marks: 4,
              answer: "An acid reacts with a base to form a salt and water. Example: Rubbing coral lime (base) on a bee sting (acidic) to reduce pain, or adding lime to acidic soil to improve crop growth."
            },
            {
              id: 5,
              question: "Write word equations for: (a) rusting of iron (b) burning of wood (combustion).",
              marks: 4,
              answer: "(a) Iron + Oxygen + Water → Hydrated iron oxide (rust) (b) Wood + Oxygen → Carbon dioxide + Water + Heat/Energy"
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Earth and Space Science: Plate Tectonics",
      tests: [
        {
          id: "8.3-test",
          title: "Plate Tectonics and Geological Events Test",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Draw and label the internal structure of the Earth, showing the four main layers.",
              marks: 5,
              answer: "Diagram showing: Inner core (solid, hottest), Outer core (liquid), Mantle (semi-solid/plastic), Crust (thin, solid outer layer)"
            },
            {
              id: 2,
              question: "Name and describe the THREE types of plate boundaries. Which type causes the most volcanic activity?",
              marks: 7,
              answer: "1. Convergent: plates move toward each other, can cause subduction/mountains 2. Divergent: plates move apart, new crust forms 3. Transform: plates slide past each other, causes earthquakes. Convergent boundaries cause the most volcanic activity (subduction zones)."
            },
            {
              id: 3,
              question: "Explain why Vanuatu experiences frequent earthquakes and volcanic eruptions. Include the term 'Pacific Ring of Fire' in your answer.",
              marks: 6,
              answer: "Vanuatu is located on the Pacific Ring of Fire, a zone of intense tectonic activity around the Pacific Ocean. The Indo-Australian Plate is subducting beneath the Pacific Plate near Vanuatu, creating a convergent boundary. This causes frequent earthquakes and volcanic eruptions as magma rises through the crust."
            },
            {
              id: 4,
              question: "Explain how a tsunami is generated and list THREE safety measures people in Vanuatu should take.",
              marks: 6,
              answer: "A tsunami is generated by a sudden displacement of water, usually from an underwater earthquake, volcanic eruption, or landslide. Safety measures: 1. Move to high ground immediately after strong shaking 2. Listen for official warnings 3. Move away from the coast and low-lying areas. Also: know evacuation routes, don't go to the beach to watch."
            },
            {
              id: 5,
              question: "Name the three types of rocks and explain how ONE type is formed.",
              marks: 5,
              answer: "Igneous, Sedimentary, Metamorphic. Example: Igneous rocks form when molten magma or lava cools and solidifies (e.g., basalt from fast-cooling lava). OR Sedimentary rocks form from layers of sediment compressed over time (e.g., limestone). OR Metamorphic rocks form when existing rocks are changed by heat and pressure (e.g., marble from limestone)."
            }
          ]
        }
      ]
    },
    strand4: {
      name: "Physical Science: Energy Transfer",
      tests: [
        {
          id: "8.4-test",
          title: "Energy Transfer and Transformation Test",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "Name SEVEN forms of energy.",
              marks: 7,
              answer: "Kinetic, potential (gravitational), thermal (heat), light, sound, electrical, chemical"
            },
            {
              id: 2,
              question: "Describe the energy transformations that occur in a solar panel system used in a Vanuatu village.",
              marks: 4,
              answer: "Solar (light) energy → Electrical energy (in solar panel) → Chemical energy (stored in battery) → Electrical energy (when used) → Light/Heat/Sound energy (in devices)"
            },
            {
              id: 3,
              question: "State the law of conservation of energy and explain it using a falling coconut as an example.",
              marks: 4,
              answer: "Energy cannot be created or destroyed, only transformed. A coconut on a tree has gravitational potential energy. As it falls, potential energy transforms to kinetic energy. When it hits the ground, kinetic energy transforms to sound and heat energy. Total energy remains the same."
            },
            {
              id: 4,
              question: "Draw a simple series circuit with a battery, switch, and two bulbs. What happens if one bulb breaks in a series circuit?",
              marks: 5,
              answer: "Diagram should show battery, switch, and two bulbs all connected in one loop. If one bulb breaks, the circuit is broken and BOTH bulbs go out because there is only one path for current."
            },
            {
              id: 5,
              question: "Explain the difference between series and parallel circuits. Why are houses in Vanuatu wired in parallel?",
              marks: 5,
              answer: "Series: components connected in one loop, same current through all, if one breaks all stop. Parallel: components on separate branches, each gets full voltage, if one breaks others continue. Houses use parallel so each device operates independently and receives full voltage."
            }
          ]
        }
      ]
    }
  }
};

export const year9ScienceUnitTests = {
  year: 9,
  subject: "Basic Science",
  strands: {
    strand1: {
      name: "Biological Science",
      tests: [
        {
          id: "9.1-test",
          title: "Organisms and Environment Test",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Define the term 'environmental stimulus' and give two examples of biotic and two examples of abiotic stimuli.",
              marks: 5,
              answer: "An environmental stimulus is any change in the environment that an organism can detect and respond to. Biotic: presence of predators, competition for food. Abiotic: temperature change, light intensity change."
            },
            {
              id: 2,
              question: "Draw and label a neuron, identifying the dendrite, cell body, and axon. Explain the function of each part.",
              marks: 6,
              answer: "Dendrite: receives signals from other neurons or receptors. Cell body: contains the nucleus, processes information. Axon: carries electrical impulses away from the cell body to the next neuron or effector."
            },
            {
              id: 3,
              question: "Explain the difference between a reflex response and a voluntary reaction. Give one example of each.",
              marks: 4,
              answer: "A reflex is an automatic, rapid response that does not involve conscious thought (e.g., pulling hand from hot object). A voluntary reaction requires conscious thought and is slower (e.g., deciding to pick up a pen)."
            },
            {
              id: 4,
              question: "Name and define three types of plant tropisms.",
              marks: 6,
              answer: "Phototropism: growth response towards/away from light. Gravitropism: growth response to gravity (roots grow down, shoots grow up). Hydrotropism: growth response towards water."
            },
            {
              id: 5,
              question: "Describe how coral spawning is triggered by environmental stimuli.",
              marks: 4,
              answer: "Coral spawning is triggered by a combination of environmental stimuli including water temperature, lunar cycle (usually after a full moon), and day length. These signals synchronise mass spawning events."
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Chemical Science",
      tests: [
        {
          id: "9.2-test",
          title: "Chemical Reactions and Atoms Test",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Distinguish between a physical change and a chemical change. Give two examples of each.",
              marks: 4,
              answer: "Physical change: no new substance formed, reversible (e.g., melting ice, dissolving salt). Chemical change: new substance formed, usually irreversible (e.g., burning wood, rusting iron)."
            },
            {
              id: 2,
              question: "Draw a labelled diagram of an atom showing protons, neutrons, and electrons. Calculate the atomic number and mass number of Carbon-12.",
              marks: 6,
              answer: "Diagram showing nucleus with protons (+) and neutrons, electrons orbiting in shells. Carbon-12: Atomic number = 6 (number of protons), Mass number = 12 (protons + neutrons = 6 + 6)."
            },
            {
              id: 3,
              question: "Balance the following equation: Mg + O2 → MgO",
              marks: 3,
              answer: "2Mg + O2 → 2MgO"
            },
            {
              id: 4,
              question: "State the law of conservation of mass. Explain why the total mass of reactants equals the total mass of products.",
              marks: 4,
              answer: "The law of conservation of mass (Lavoisier) states that matter cannot be created or destroyed in a chemical reaction. The total mass of reactants equals products because atoms are rearranged, not created or destroyed."
            },
            {
              id: 5,
              question: "Calculate the number of moles in 44g of CO2 (C=12, O=16).",
              marks: 4,
              answer: "Molar mass of CO2 = 12 + (2 × 16) = 44 g/mol. Number of moles = mass / molar mass = 44 / 44 = 1 mole."
            },
            {
              id: 6,
              question: "Explain the difference between exothermic and endothermic reactions. Give one example of each.",
              marks: 4,
              answer: "Exothermic: releases energy/heat to surroundings, temperature increases (e.g., combustion). Endothermic: absorbs energy/heat from surroundings, temperature decreases (e.g., photosynthesis)."
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Earth and Space Science",
      tests: [
        {
          id: "9.3-test",
          title: "Plate Tectonics Test",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Describe Wegener's continental drift theory and give two pieces of evidence that support plate tectonics.",
              marks: 5,
              answer: "Wegener proposed that continents were once joined (Pangaea) and drifted apart. Evidence: Continental fit (coastlines of South America and Africa match), similar fossils found on separate continents, matching rock types across continents."
            },
            {
              id: 2,
              question: "Name and describe the three types of plate boundary movements.",
              marks: 6,
              answer: "Convergent: plates move towards each other (creates mountains, subduction zones). Divergent: plates move apart (creates new ocean floor, rift valleys). Transform: plates slide past each other (creates earthquakes)."
            },
            {
              id: 3,
              question: "Explain why Vanuatu experiences frequent volcanic eruptions and earthquakes.",
              marks: 4,
              answer: "Vanuatu is located on the Pacific Ring of Fire, at the boundary between the Pacific Plate and the Australian-Indian Plate. The Pacific Plate subducts under the Australian-Indian Plate, causing volcanic activity and earthquakes."
            },
            {
              id: 4,
              question: "Explain how earthquakes can cause tsunamis.",
              marks: 4,
              answer: "Earthquakes under the ocean floor cause sudden displacement of water. When the sea floor moves up or down at a plate boundary, it displaces a large volume of water, creating waves that travel outward as a tsunami."
            },
            {
              id: 5,
              question: "List three safety instructions for an earthquake event.",
              marks: 3,
              answer: "Drop, cover and hold on under sturdy furniture. Move away from windows and heavy objects. If outdoors, move to open area away from buildings, trees and power lines."
            }
          ]
        }
      ]
    },
    strand4: {
      name: "Physical Science",
      tests: [
        {
          id: "9.4-test",
          title: "Light and Sound Test",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "State the law of reflection and draw a ray diagram showing reflection from a plane mirror.",
              marks: 5,
              answer: "The law of reflection states that the angle of incidence equals the angle of reflection (measured from the normal). Diagram should show incident ray, reflected ray, normal line, and equal angles."
            },
            {
              id: 2,
              question: "Compare convex and concave mirrors. What type of image does each produce?",
              marks: 4,
              answer: "Convex mirror: curved outward, always produces virtual, upright, smaller images (used in car side mirrors). Concave mirror: curved inward, can produce real/virtual images depending on object position (used in torches, satellite dishes)."
            },
            {
              id: 3,
              question: "Explain why light refracts when passing from air into water.",
              marks: 3,
              answer: "Light changes speed when moving from one medium to another. When light passes from air (less dense) into water (more dense), it slows down and bends towards the normal."
            },
            {
              id: 4,
              question: "Name three parts of the human eye and explain the function of each.",
              marks: 6,
              answer: "Cornea: transparent front part, refracts light. Lens: focuses light onto retina by changing shape. Retina: contains light-sensitive cells (rods and cones), converts light into nerve impulses."
            },
            {
              id: 5,
              question: "Explain why sound cannot travel through a vacuum.",
              marks: 3,
              answer: "Sound travels by vibrating particles in a medium (solid, liquid, gas). A vacuum has no particles, so there is nothing to vibrate and transmit sound energy."
            },
            {
              id: 6,
              question: "Distinguish between infrasound, audible sound, and ultrasound. Give one use of ultrasound.",
              marks: 4,
              answer: "Infrasound: below 20 Hz (below human hearing range). Audible sound: 20 Hz to 20,000 Hz (human hearing range). Ultrasound: above 20,000 Hz (above human hearing). Uses of ultrasound: medical imaging, echolocation in bats/dolphins, sonar."
            }
          ]
        }
      ]
    }
  }
};

export const year10ScienceUnitTests = {
  year: 10,
  subject: "Basic Science",
  strands: {
    strand1: {
      name: "Biological Science",
      tests: [
        {
          id: "10.1-test",
          title: "Genetics and Inheritance Test",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Define the following terms: gene, DNA, chromosome. Explain the relationship between them.",
              marks: 6,
              answer: "Gene: a section of DNA that codes for a specific protein/trait. DNA: deoxyribonucleic acid, the molecule that carries genetic information. Chromosome: a coiled structure of DNA and protein found in the nucleus. Relationship: genes are segments of DNA, DNA is packaged into chromosomes."
            },
            {
              id: 2,
              question: "Differentiate between mitosis and meiosis. State the purpose and outcome of each.",
              marks: 6,
              answer: "Mitosis: cell division producing 2 identical daughter cells (diploid), used for growth and repair. Meiosis: cell division producing 4 genetically different daughter cells (haploid), used for producing gametes (sex cells)."
            },
            {
              id: 3,
              question: "In pea plants, tall (T) is dominant over short (t). Cross a heterozygous tall plant (Tt) with a short plant (tt). Draw a Punnett square and state the expected phenotype ratio.",
              marks: 6,
              answer: "Punnett square: Tt x tt gives Tt, Tt, tt, tt. Genotype ratio: 2 Tt : 2 tt (1:1). Phenotype ratio: 2 tall : 2 short (1:1 or 50% tall, 50% short)."
            },
            {
              id: 4,
              question: "Explain what a sex-linked trait is. Give two examples of sex-linked conditions.",
              marks: 4,
              answer: "A sex-linked trait is a trait whose gene is located on the sex chromosomes (usually the X chromosome). Examples: haemophilia and red-green colour blindness. These conditions are more common in males because they only have one X chromosome."
            },
            {
              id: 5,
              question: "Explain the difference between selective breeding and genetic modification. Give one agricultural example of each.",
              marks: 5,
              answer: "Selective breeding: choosing organisms with desired traits to breed together over many generations (e.g., breeding cattle for higher milk yield). Genetic modification: directly altering DNA by inserting genes from another organism (e.g., GM pawpaw resistant to ringspot virus)."
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Chemical Science",
      tests: [
        {
          id: "10.2-test",
          title: "Chemical Reactions and Bonding Test",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Write the electron configuration of sodium (Na, atomic number 11) and chlorine (Cl, atomic number 17). Explain how they form an ionic bond.",
              marks: 6,
              answer: "Na: 2,8,1. Cl: 2,8,7. Sodium loses 1 electron to form Na+ (2,8). Chlorine gains 1 electron to form Cl- (2,8,8). The opposite charges attract, forming an ionic bond (NaCl)."
            },
            {
              id: 2,
              question: "Explain the difference between ionic and covalent bonding. Give one example of each.",
              marks: 4,
              answer: "Ionic: transfer of electrons from metal to non-metal (e.g., NaCl). Covalent: sharing of electrons between non-metal atoms (e.g., H2O)."
            },
            {
              id: 3,
              question: "Using the activity series, predict whether zinc will displace copper from copper sulfate solution. Write a word equation.",
              marks: 4,
              answer: "Yes, zinc is more reactive than copper in the activity series, so it will displace copper. Zinc + Copper sulfate → Zinc sulfate + Copper."
            },
            {
              id: 4,
              question: "Explain collision theory and how increasing temperature affects the rate of reaction.",
              marks: 5,
              answer: "Collision theory: reactions occur when particles collide with enough energy (activation energy) and correct orientation. Increasing temperature gives particles more kinetic energy, so they move faster, collide more frequently and with more energy, increasing the rate of reaction."
            },
            {
              id: 5,
              question: "Explain why crushing a solid into powder increases the rate of reaction.",
              marks: 3,
              answer: "Crushing increases the surface area exposed to the other reactant. More surface area means more particles are available for collision, leading to more frequent collisions and a faster reaction rate."
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Earth and Space Science",
      tests: [
        {
          id: "10.3-test",
          title: "Climate Change Test",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Name Earth's four spheres and describe how the water cycle connects at least two of them.",
              marks: 5,
              answer: "Biosphere (living things), geosphere (rocks/land), hydrosphere (water), atmosphere (air). The water cycle: water evaporates from hydrosphere into atmosphere (evaporation), falls back as precipitation to geosphere/hydrosphere, absorbed by biosphere (plants/animals)."
            },
            {
              id: 2,
              question: "Explain the greenhouse effect. Why is it essential for life on Earth?",
              marks: 4,
              answer: "The greenhouse effect is the trapping of heat by greenhouse gases (CO2, methane, water vapour) in the atmosphere. Solar radiation passes through the atmosphere, warms the Earth's surface, which re-radiates infrared radiation. Greenhouse gases absorb and re-emit this radiation, keeping Earth warm enough to support life."
            },
            {
              id: 3,
              question: "List three main greenhouse gases and explain how human activities have increased their concentration.",
              marks: 6,
              answer: "CO2: increased by burning fossil fuels, deforestation. Methane (CH4): increased by livestock farming, rice paddies, landfills. Nitrous oxide (N2O): increased by agriculture (fertilisers), industrial processes."
            },
            {
              id: 4,
              question: "Describe three ways climate change specifically affects Vanuatu.",
              marks: 6,
              answer: "Sea level rise threatening coastal communities and low-lying islands. More intense tropical cyclones causing destruction. Coral bleaching from warmer ocean temperatures affecting marine biodiversity and fisheries. Ocean acidification. Saltwater intrusion into freshwater supplies."
            },
            {
              id: 5,
              question: "What is the Paris Agreement? What are its main objectives?",
              marks: 4,
              answer: "The Paris Agreement (2015) is an international treaty on climate change. Main objectives: limit global warming to well below 2°C above pre-industrial levels (ideally 1.5°C), strengthen adaptation, provide financial support to developing nations."
            }
          ]
        }
      ]
    },
    strand4: {
      name: "Physical Science",
      tests: [
        {
          id: "10.4-test",
          title: "Motion and Safety Test",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Calculate the work done when a force of 50 N moves an object 4 metres. State the unit.",
              marks: 3,
              answer: "Work = Force × Distance = 50 × 4 = 200 J (Joules)"
            },
            {
              id: 2,
              question: "A machine has a work input of 500 J and a useful work output of 350 J. Calculate its efficiency.",
              marks: 3,
              answer: "Efficiency = (Useful work output / Work input) × 100 = (350/500) × 100 = 70%"
            },
            {
              id: 3,
              question: "State Newton's first law of motion. Use it to explain why passengers lurch forward when a car stops suddenly.",
              marks: 4,
              answer: "Newton's first law: an object remains at rest or moves at constant velocity unless acted upon by an unbalanced force (inertia). When a car stops suddenly, passengers continue moving forward due to inertia because their bodies resist the change in motion."
            },
            {
              id: 4,
              question: "A car of mass 1200 kg accelerates at 2 m/s². Calculate the force applied. (F = ma)",
              marks: 3,
              answer: "F = m × a = 1200 × 2 = 2400 N"
            },
            {
              id: 5,
              question: "Calculate the momentum of a 1500 kg truck travelling at 20 m/s. Explain why braking distance increases with speed.",
              marks: 5,
              answer: "Momentum = mass × velocity = 1500 × 20 = 30,000 kg m/s. Braking distance increases with speed because at higher speeds, the vehicle has more kinetic energy and momentum that needs to be absorbed by braking friction, requiring a longer distance to stop."
            },
            {
              id: 6,
              question: "Name two vehicle safety features and explain how each relates to Newton's laws.",
              marks: 4,
              answer: "Seatbelts: provide the unbalanced force to stop passengers (Newton's 1st law - prevents continued forward motion due to inertia). Crumple zones: extend the time of collision, reducing the force on passengers (Newton's 2nd law - same momentum change over longer time = smaller force)."
            }
          ]
        }
      ]
    }
  }
};

export default {
  year7ScienceUnitTests,
  year8ScienceUnitTests,
  year9ScienceUnitTests,
  year10ScienceUnitTests
};
